import { getCurrentImagesCdnService } from '../services/configuration';

export default function ImageCdn(props) {
  const { ImageCdn: CurrentImageCdnComponent } = getCurrentImagesCdnService();

  return <CurrentImageCdnComponent {...props} />;
}
